import { library, IconDefinition } from "@fortawesome/fontawesome-svg-core";

export function setupIcons(icons: IconDefinition[]) {
    library.add(...icons);
}
